/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import LoginComponent from './site-login';
import { isUserLoggedIn } from 'state/current-user/selectors';
import JwtLoginComponent from './jwt-login';
import config from 'config';

// const OAUTH2_AUTHORIZE_URL =
//     'https://ecc-dev2.towersystems.com.au/oauth2/authorize' +
//     '?return_url=https://ecc-client2.towersystems.com.au/jwt-login';

const OAUTH2_AUTHORIZE_URL =
    config('oauth2ServerUrl') + '/oauth2/authorize' +
    '?return_url=' + config('clientUrl') + '/jwt-login';

// export const login = (context, next) => {
//     const userLoggedIn = isUserLoggedIn(context.store.getState());

//     if (userLoggedIn) {
//         window.location = '/';
//         return;
//     }

//     // Send user to Eureka via eccserver instead of showing the login form
//     window.location = OAUTH2_AUTHORIZE_URL;
// };

export const login = (context, next) => {
    const userLoggedIn = isUserLoggedIn(context.store.getState());
    const hasToken = !!localStorage.getItem('currentUserJWT');

      console.log('login controller - userLoggedIn:', userLoggedIn);
    console.log('login controller - hasToken:', hasToken);

    if (userLoggedIn || hasToken) {
        window.location = '/';
        return;
    }

    // Send user to Eureka via eccserver instead of showing the login form
    window.location = OAUTH2_AUTHORIZE_URL;
};

// export const jwtLogin = (context, next) => {
//     const userLoggedIn = isUserLoggedIn(context.store.getState());

//     if (userLoggedIn) {
//         window.location = '/';
//         return;
//     }

//     // eccserver returns ?token=... (not ?jwt=...)
//     context.primary = <JwtLoginComponent jwt={context.query.token} />;
//     next();
// };

export const jwtLogin = (context, next) => {
    const userLoggedIn = isUserLoggedIn(context.store.getState());
    const hasToken = !!localStorage.getItem('currentUserJWT');

    if (userLoggedIn || hasToken) {
        window.location = '/';
        return;
    }

    context.primary = <JwtLoginComponent jwt={context.query.token} />;
    next();
};